import React from 'react'
import noData from "./images/no-data.svg"
import { BsClipboardData } from "react-icons/bs";
function NoData() {
    return (
        <div className="spinner spinner-m">
            <img src={noData} alt="error" />
            <h2 className="greet">No Data <BsClipboardData /> </h2>
        </div>
    )
}

export default NoData
